import { AppContent } from 'content/AppContent';

const sessionTimedOut: AppContent['sessionTimedOut'] = {
  sessionTimedOutContent: [
    {
      serviceName: 'Business Internet Banking',
      heading: 'Your session has timed out',
      content1:
        'It looks like you’re not there, so we’ve closed your session to keep your details safe.',
      tryAgainButton: 'Try again',
      tryAgainLink: '/',
    },
  ],
};

export default sessionTimedOut;
